// ============================================
// ACCORDION — Product Detail Tabs
// ============================================
document.addEventListener('DOMContentLoaded', function () {
  function initAccordions() {
    const triggers = document.querySelectorAll('.mp-accordion__trigger');
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        const content = trigger.nextElementSibling;
        triggers.forEach((t) => {
          t.setAttribute('aria-expanded', 'false');
          const c = t.nextElementSibling;
          if (c) c.classList.remove('open');
        });
        if (!expanded) {
          trigger.setAttribute('aria-expanded', 'true');
          if (content) content.classList.add('open');
        }
      });
    });
  }
  initAccordions();
});